

export function fwgpricecent(value, mode = "long") {
	let prefix = ""
	if (mode == "long") {
		prefix = "CHF "
	}
	else if (mode == "html") {
		prefix = "CHF&nbsp;"
	}

	let v = value / 100
	v = v || 0
	return prefix + v.toFixed(2)
}

export function fwgcmstext(value) {
	let type = typeof value
	if (type == "string") {
		return value
			.replace(/(\r\n|\n)/g, "<br>")
	} else if (type == "number") {
		return value.toString()
	}
	return ""
}

export function fwgmark(value, start = '<span class="text--highlight">', end = '</span>') {
	if (value.includes('[mark]') && value.includes('[/mark]')) {
		return value
			.replace('[mark]', start)
			.replace('[/mark]', end)
	}
	return value
}

export function stripHtml(value) {
  if (!value) {
    return ''
  }

  return String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

export default class FilterFwg {
	static install(Vue, options) {
		Vue.filter('fwgpricecent', fwgpricecent)
		Vue.filter('fwgcmstext', fwgcmstext)
		Vue.filter('fwgmark', fwgmark)
		Vue.filter('stripHtml', stripHtml)
	}
}
